export const ATTACH_DOCUMENTS = 'ATTACH_DOCUMENTS'
export const ATTACH_DOCUMENTS_FAILED = 'ATTACH_DOCUMENTS_FAILED'
export const ATTACH_DOCUMENTS_SUCCEEDED = 'ATTACH_DOCUMENTS_SUCCEEDED'
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT'
export const DELETE_ATTACHMENT_FAILED = 'DELETE_ATTACHMENT_FAILED'
export const DELETE_ATTACHMENT_SUCCEEDED = 'DELETE_ATTACHMENT_SUCCEEDED'
export const DELETE_EXPENSE = 'DELETE_EXPENSE'
export const DELETE_EXPENSE_FAILED = 'DELETE_EXPENSE_FAILED'
export const DELETE_EXPENSE_SUCCEEDED = 'DELETE_EXPENSE_SUCCEEDED'
export const FETCH_EXPENSE = 'FETCH_EXPENSE'
export const FETCH_EXPENSE_FAILED = 'FETCH_EXPENSE_FAILED'
export const FETCH_EXPENSE_SUCCEEDED = 'FETCH_EXPENSE_SUCCEEDED'
export const FETCH_EXPENSES = 'FETCH_EXPENSES'
export const FETCH_EXPENSES_FAILED = 'FETCH_EXPENSES_FAILED'
export const FETCH_EXPENSES_SUCCEEDED = 'FETCH_EXPENSES_SUCCEEDED'
export const SET_SELECTED_DOCUMENT = 'SET_SELECTED_DOCUMENT'
export const UPDATE_EXPENSE = 'UPDATE_EXPENSE'
export const UPDATE_EXPENSE_FAILED = 'UPDATE_EXPENSE_FAILED'
export const UPDATE_EXPENSE_SUCCEEDED = 'UPDATE_EXPENSE_SUCCEEDED'
export const UPDATE_FILTER_STRING = 'UPDATE_FILTER_STRING'
export const SOCKET_DOCUMENT_CREATED = 'SOCKET_DOCUMENT_CREATED'
export const SOCKET_DOCUMENT_UPDATED = 'SOCKET_DOCUMENT_UPDATED'
export const SOCKET_DOCUMENT_UPLOAD = 'SOCKET_DOCUMENT_UPLOAD'
export const FETCH_DOCS_WORKFLOW_SEARCH = 'FETCH_DOCS_WORKFLOW_SEARCH'
export const FETCH_DOCS_WORKFLOW_SEARCH_FAILED = 'FETCH_DOCS_WORKFLOW_SEARCH_FAILED'
export const FETCH_DOCS_WORKFLOW_SEARCH_SUCCEEDED = 'FETCH_DOCS_WORKFLOW_SEARCH_SUCCEEDED'
